<template>
  <BtnDropdown :title="$t('engine.manageText.modalWidget.tooltip.lblAlign', languageEngine)">
    <template #button-content>
      <span v-show="_value == 'left'"><i class="far fa-align-left fs-16"></i></span>
      <span v-show="_value == 'center'"><i class="far fa-align-center fs-16"></i></span>
      <span v-show="_value == 'right'"><i class="far fa-align-right fs-16"></i></span>
      <span v-show="_value == 'justify'"><i class="far fa-align-justify fs-16"></i></span>
      <span class="ml-2 text-muted"><i class="fas fa-chevron-down fs-10"></i></span>
    </template>

    <div style="width: max-content;">
      <div class="row -mx-0">
        <div class="col-3 px-0"><ToolAlignLeft :value="_value == 'left'" @click="$emit('change', 'left')" /></div>
        <div class="col-3 px-0"><ToolAlignCenter :value="_value == 'center'" @click="$emit('change', 'center')" /></div>
        <div class="col-3 px-0"><ToolAlignRight :value="_value == 'right'" @click="$emit('change', 'right')" /></div>
        <div class="col-3 px-0"><ToolAlignJustify :value="_value == 'justify'" @click="$emit('change', 'justify')" /></div>
      </div>
    </div>
  </BtnDropdown>
</template>

<script>
import { mapGetters } from "vuex";
import BtnDropdown from "./_BtnDropdown";
import ToolAlignLeft from "./AlignLeft";
import ToolAlignCenter from "./AlignCenter";
import ToolAlignRight from "./AlignRight";
import ToolAlignJustify from "./AlignJustify";

export default {
  components: {
    BtnDropdown,
    ToolAlignLeft,
    ToolAlignCenter,
    ToolAlignRight,
    ToolAlignJustify
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    value() {
      if (Array.isArray(this.selectionFormatMerge.align)) return this.selectionFormatMerge.align[0];
      return this.selectionFormatMerge.align;
    },
    _value() {
      if (!this.value) return 'left';
      return this.value;
    }
  },
}
</script>
